/**
 * Luli For Babies — Vistos recentemente (réplica do RecentlyViewed do site Lovable).
 *
 * - Em páginas de produto, registra o handle no localStorage (máx. 12, sem duplicatas).
 * - O custom element <luli-recently-viewed> busca cada produto via /products/{handle}.js
 *   e renderiza cards compactos no estilo Luli. Se não houver histórico, a seção some.
 */
(function () {
  const STORAGE_KEY = 'luli:recently-viewed';
  const MAX_STORED = 12;

  function readHandles() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((h) => typeof h === 'string') : [];
    } catch (e) {
      return [];
    }
  }

  function recordCurrentProduct() {
    const match = window.location.pathname.match(/\/products\/([a-z0-9\-_%]+)/i);
    if (!match) return;
    const handle = decodeURIComponent(match[1]);
    const handles = readHandles().filter((h) => h !== handle);
    handles.unshift(handle);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
    } catch (e) {
      /* localStorage indisponível — ignora */
    }
  }

  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  class LuliRecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.maxItems = parseInt(this.dataset.max || '8', 10);
      this.exclude = this.dataset.exclude || '';
      this.pixDiscount = parseFloat(this.dataset.pixDiscount || '5');

      // "Vistos recentemente" fica no rodapé da home e faz até 8 fetches de
      // produto. Disparar no load competiria por banda com o herói, na janela
      // do LCP. Só busca quando a seção se aproxima da viewport. Sem
      // IntersectionObserver (navegador antigo), cai no comportamento anterior.
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries, obs) => {
          if (entries.some((e) => e.isIntersecting)) {
            obs.disconnect();
            this.render();
          }
        }, { rootMargin: '400px' });
        io.observe(this);
      } else {
        this.render();
      }
    }

    async render() {
      const handles = readHandles()
        .filter((h) => h !== this.exclude)
        .slice(0, this.maxItems);

      const sectionWrapper = this.closest('.luli-recent-section');
      if (handles.length === 0) {
        if (sectionWrapper) sectionWrapper.hidden = true;
        return;
      }

      const products = (
        await Promise.all(
          handles.map((handle) =>
            fetch('/products/' + encodeURIComponent(handle) + '.js')
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null)
          )
        )
      ).filter(Boolean);

      if (products.length === 0) {
        if (sectionWrapper) sectionWrapper.hidden = true;
        return;
      }

      const list = this.querySelector('[ref="list"]');
      if (!list) return;

      list.innerHTML = products
        .map((product) => {
          const image = product.featured_image
            ? product.featured_image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_400x$1$2')
            : '';
          const pix = Math.round(product.price * (1 - this.pixDiscount / 100));
          return (
            '<a class="luli-recent__card" href="' + product.url + '">' +
            (image
              ? '<img class="luli-recent__image" loading="lazy" src="' + image + '" alt="">'
              : '<span class="luli-recent__image luli-recent__image--empty"></span>') +
            '<span class="luli-recent__title">' + product.title + '</span>' +
            '<span class="luli-recent__price">' + formatMoney(pix) + ' <small>no pix</small></span>' +
            '</a>'
          );
        })
        .join('');
    }
  }

  if (!customElements.get('luli-recently-viewed')) {
    customElements.define('luli-recently-viewed', LuliRecentlyViewed);
  }

  recordCurrentProduct();
})();
